export default "__VITE_ASSET__30fa0b70__"